// extracted by mini-css-extract-plugin
export default {"Wrapper":"Wrapper_Wrapper__dpG13","center":"Wrapper_center__QZnFs"};